<template>
	<div>
		<page-heading>{{ heading }}
			<base-button custom-classes="pull-right" colour="primary" type="button" v-on:click="onSubmit">{{ buttonLabel }}</base-button>
		</page-heading>
		<base-form :schema="schema" :errors="errors" v-model="form" />
	</div>
</template>
<script>
import schema from "./FinancialAccountForm.json"
import Renderer from "../forms-bs3/Renderer.vue";
import BaseFormSection from "../forms-bs3/BaseFormSection.vue";
import BaseForm from "../forms-bs3/BaseForm.vue";
import PageHeading from "../ui/display/PageHeading.vue";
import BaseButton from "../forms-bs3/BaseButton.vue";
import api from '../../api'

export default {
	components: {PageHeading, BaseForm, BaseFormSection, Renderer, BaseButton},
	props: {
		financialAccount: {
			type: Object,
			required: false
		},
		heading: {
			type: String,
			required: true
		},
		buttonLabel: {
			type: String,
			required: true
		}
	},
	computed: {
		mode() {
			return this.financialAccount?.id != null ? 'edit' : 'create' 
		}
	},
	data() {
		return {
			schema: schema,
			form: this.financialAccount,
			errors: {}
		}	
	},
	methods: {
		onSubmit() {
			if (this.mode === 'edit') {
				api.financial_accounts.updateFinancialAccount(this.form)
					.then(() => {
							api.navigator.navigateToRoute(route('club.financial_accounts', { domain: window.SwimManagerConfig.apiDomain }))
					})
					.catch((error) => {
						console.log(error.response.data)
						this.errors = error.response.data.errors
					})
			}
			else {
				api.financial_accounts.createFinancialAccount(this.form)
					.then((response) => {
						api.navigator.navigateToRoute(route('club.financial_accounts', {domain: window.SwimManagerConfig.apiDomain}))
					})
					.catch((error) => {
						console.log(error.message, JSON.stringify(error.response));
						this.errors = error.response.data.errors
					})
				
			}
		},
	}
}
</script>